const de = {
    common: {
        previousPage: "Vorherige Seite",
        nextPage: "Nächste Seite",
        unknownUser: "Unbekannter Nutzer",
        cancel: "Abbrechen",
        close: "Schließen",
        loading: "Lädt …",
        required: "Erforderlich",
        units: {
            ml: "ml",
            min: "min",
        },
    },
    app: {
        updateAvailable: "Eine neue Version von Saufdings ist verfügbar.",
        reload: "Neu laden",
        theme: {
            dark: "Dunkel",
            light: "Hell",
            label: "Darstellung",
        },
    },
    eventStats: {
        authRequired: {
            title: "Event-Statistiken",
            description: "Melde dich an, um Event-Leaderboards und detaillierte Auswertungen zu sehen.",
        },
        header: {
            title: "Event-Statistiken",
            subtitle: "Sieh, wer was getrunken hat, wie viel reiner Alkohol zusammenkam und wie sich das Event entwickelt hat.",
            selectPlaceholder: "Event auswählen",
            optionNoStart: "Keine Startzeit",
            startedLabel: "Gestartet {{time}}",
            errorTitle: "Statistiken konnten nicht geladen werden",
            retryLabel: "Statistiken erneut laden",
        },
        visibilityOptions: {
            public: "Öffentlich",
            friends: "Nur Freunde",
            password: "Passwortgeschützt",
            private: "Privat",
            unknown: "Unbekannt",
            passwordSuffix: " (Passwort)",
        },
        visibilityCard: {
            title: "Sichtbarkeit für beendete Events",
            currentLabel: "Aktuelle Sichtbarkeit",
            description: "Das Event ist vorbei, aber du kannst weiterhin festlegen, wer die Statistiken sieht.",
            form: {
                visibilityLabel: "Sichtbarkeit",
                visibilityRequired: "Wähle eine Sichtbarkeit.",
                passwordLabel: "Zugriffspasswort",
                passwordRequired: "Bitte gib ein Passwort für das Event ein.",
                passwordPlaceholder: "Phrase eingeben",
                submit: "Sichtbarkeit aktualisieren",
            },
            deleteConfirmTitle: "Event löschen?",
            deleteConfirmDescription: "Alle Statistiken, Drinks und Turniere werden dauerhaft entfernt.",
            deleteConfirmOk: "Löschen",
            deleteButton: "Event löschen",
        },
        messages: {
            visibilityUpdated: "Sichtbarkeit aktualisiert.",
            visibilityUpdateError: "Sichtbarkeit konnte nicht geändert werden.",
            deleteSuccess: "Event gelöscht.",
            deleteError: "Event konnte nicht gelöscht werden.",
            loadStatsError: "Event-Statistiken konnten nicht geladen werden.",
            loadEventsError: "Events konnten nicht geladen werden.",
        },
        empty: {
            selectPrompt: "Wähle ein Event, um die Statistiken zu sehen",
        },
        summary: {
            label: "Event",
            started: "Gestartet {{time}}",
            ended: " · Beendet {{time}}",
            startUnknown: "Startzeit unbekannt",
            stats: {
                visibleParticipants: "Sichtbare Teilnehmer",
                totalEntries: "Einträge gesamt",
                pureAlcohol: "Reiner Alkohol",
                totalLiquid: "Flüssigkeit gesamt",
            },
        },
        filters: {
            title: "Filter",
            drinkLabel: "Drink-Filter",
            drinkPlaceholder: "Alle Drinks",
            participantsLabel: "Sichtbare Teilnehmer",
            participantsPlaceholder: "Teilnehmer auswählen",
            showAll: "Alle anzeigen",
            hideAll: "Alle ausblenden",
        },
        cards: {
            topAlcoholTitle: "Meiste Alkoholmenge dieses Events",
            topAlcoholEntry: "{{alcohol}} · {{volume}} · {{entries}} Einträge",
            selectedDrinkTitle: "Leaderboard für {{drink}}",
            participantTitle: "Teilnehmer-Leaderboard",
            categoryBreakdown: "Kategorie-Übersicht",
            drinkBreakdown: "Drink-Übersicht",
            topDrinksTitle: "Top-Drinks",
            topCategoriesTitle: "Top-Kategorien",
            timelineLiquidTitle: "Timeline (Flüssigkeit pro Stunde)",
            timelineLiquidEmpty: "Noch keine Timeline-Daten für dieses Event.",
            timelineAlcoholTitle: "Timeline (reiner Alkohol pro Stunde)",
            timelineAlcoholEmpty: "Noch keine Alkohol-Timeline-Daten.",
            timelineTooltipAlcohol: "Reiner Alkohol",
            totalLabel: "Gesamt: {{volume}} · {{alcohol}}",
            topBeerTitle: "Top Bier-Fans",
            beerFallback: "Keine bier-spezifischen Daten – zeige den besten Gesamtwert als Referenz.",
            topShotsTitle: "Top Shots & Spirituosen",
            shotsFallback: "Keine Shots/Spirituosen gefunden – zeige den nächstbesten Wert.",
            topDrinkersLabel: "Top-Trinker",
            noTopConsumer: "Noch kein Top-Trinker.",
            noBeerData: "Noch keine Bier-Aktivität.",
            noShotsData: "Noch keine Shots- oder Spirituosen-Aktivität.",
        },
        tables: {
            expandColumn: "Teilnehmerdetails aufklappen",
            participantsEmpty: "Keine Teilnehmer passen zu den aktuellen Filtern.",
            drinkEmpty: "Für dieses Event wurden noch keine Drinks erfasst.",
            categoryEmpty: "Keine Kategorien verfügbar.",
            selectedDrinkColumns: {
                participant: "Teilnehmer",
                entries: "Einträge",
                liquid: "Flüssigkeit",
                alcohol: "Reiner Alkohol",
            },
            participantColumns: {
                participant: "Teilnehmer",
                details: "Details",
                entries: "Einträge",
                liquid: "Flüssigkeit",
                alcohol: "Reiner Alkohol",
                selectedDrinkVolume: "{{drink}} (ml)",
                selectedDrinkAlcohol: "{{drink}} (g)",
            },
            drinkColumns: {
                drink: "Drink",
                entries: "Einträge",
                liquid: "Flüssigkeit gesamt",
                alcohol: "Reiner Alkohol",
                topConsumer: "Top-Trinker",
            },
            categoryColumns: {
                category: "Kategorie",
                entries: "Einträge",
                liquid: "Flüssigkeit gesamt",
                alcohol: "Reiner Alkohol",
                topConsumer: "Top-Trinker",
            },
        },
        ongoing: {
            title: "Leaderboard laufender Events",
            started: "Gestartet {{time}}",
            startUnknown: "Startzeit unbekannt",
            noDrinks: "Noch keine Drinks eingetragen.",
            empty: "Keine aktiven Events mit Statistiken.",
        },
    },
    profile: {
        push: {
            title: "Drink-Erinnerung",
            description: "Zeigt nach einem kürzlich eingetragenen Drink eine dauerhafte, private Erinnerung. Benachrichtigungen enthalten keine Drink-Details und können verspätet oder gar nicht ankommen.",
            loading: "Erinnerungseinstellungen werden geladen",
            switchLabel: "Drink-Erinnerung aktivieren",
            installRequired: "Installiere Saufdings auf iOS/iPadOS 16.4 oder neuer zum Home-Bildschirm und öffne die App dort, um Benachrichtigungen zu aktivieren.",
            unsupported: "Dieser Browser unterstützt keine Push-Benachrichtigungen.",
            loadError: "Die Erinnerungseinstellungen konnten nicht geladen werden. Bitte versuche es später erneut.",
            unavailable: "Push-Benachrichtigungen sind auf diesem Server nicht verfügbar.",
            enabled: "Drink-Erinnerung aktiviert.",
            disabled: "Drink-Erinnerung deaktiviert.",
            denied: "Benachrichtigungen sind blockiert. Erlaube sie in den Browsereinstellungen und versuche es erneut.",
            error: "Die Erinnerungseinstellungen konnten nicht geändert werden. Prüfe deine Verbindung und versuche es erneut.",
        },
        accountData: {
            pendingWarning_one: "Auf diesem Gerät ist {{count}} Getränk nicht synchronisiert. Wenn du die Kontolöschung beantragst, wird es dauerhaft verworfen. Gehe zurück, um es zu behalten und zuerst zu synchronisieren.",
            pendingWarning_other: "Auf diesem Gerät sind {{count}} Getränke nicht synchronisiert. Wenn du die Kontolöschung beantragst, werden sie dauerhaft verworfen. Gehe zurück, um sie zu behalten und zuerst zu synchronisieren.",
            title: "Deine Daten",
            loading: "Kontostatus wird geladen…",
            loadError: "Dein Kontostatus konnte nicht geladen werden.",
            retry: "Erneut versuchen",
            drinksExportTitle: "Getränkeverlauf",
            drinksExportDescription: "Lade nur deine Getränke herunter. Mengen sind in Millilitern angegeben.",
            drinksExportCsv: "CSV herunterladen",
            drinksExportJson: "JSON herunterladen",
            drinksExportLoading: "Getränkeexport wird vorbereitet…",
            drinksExportEmpty: "Es gibt noch keine Getränke zum Exportieren.",
            drinksExportSuccess: "Deine Getränkedatei ist bereit.",
            drinksExportError: "Deine Getränke konnten nicht exportiert werden. Versuche es später erneut.",
            drinksExportTooLarge: "Dein Verlauf enthält mehr als 10.000 Getränke und kann nicht in einer Datei exportiert werden.",
        },
        loading: "Profil wird geladen",
        authRequired: {
            title: "Anmeldung benötigt",
            description: "Melde dich an, um dein Profil zu sehen und Drinks zu tracken.",
        },
        hero: {
            greeting: "Hey {{name}}!",
            subtitle: "Hier findest du all deine Drinks. Füge neue hinzu oder wirf einen Blick auf deine Statistiken.",
        },
        stats: {
            sectionTitle: "Deine Statistiken",
            totalVolume: "Gesamte protokollierte Menge",
            lastDrink: "Letzter eingetragener Drink",
            lastDrinkEmpty: "Noch nichts eingetragen.",
        },
        cta: {
            addDrink: "Drink hinzufügen",
            viewStats: "Statistiken ansehen",
        },
        eventsSectionTitle: "Events",
        accountSectionTitle: "Dein Konto",
        currentEvent: {
            title: "Aktuelles Event",
            refresh: "Aktualisieren",
            passwordRequired: "Passwort nötig",
            locationUnknown: "Kein Ort angegeben",
            startedLabel: "Gestartet {{time}}",
            startedUnknown: "Unbekannt",
            endedLabel: "Beendet {{time}}",
            leaveButton: "Event verlassen",
            manageAccess: "Zugriff verwalten",
            endConfirmTitle: "Dieses Event beenden?",
            endConfirmOk: "Beenden",
            endConfirmCancel: "Abbrechen",
            endButton: "Event beenden",
            deleteConfirmTitle: "Dieses Event löschen?",
            deleteConfirmDescription: "Alle Drinks, Teilnehmer und Turniere werden gelöscht. Dies kann nicht rückgängig gemacht werden.",
            deleteConfirmOk: "Löschen",
            deleteButton: "Event löschen",
            empty: "Du nimmst aktuell an keinem Event teil.",
        },
        createEvent: {
            title: "Event erstellen",
            form: {
                eventNameLabel: "Eventname",
                eventNamePlaceholder: "Geburtstagsparty",
                eventNameRequired: "Bitte gib einen Eventnamen ein.",
                locationLabel: "Ort",
                locationPlaceholder: "Optional",
                visibilityLabel: "Sichtbarkeit",
                visibilityRequired: "Wähle, wer das Event sehen darf.",
                passwordLabel: "Zugriffspasswort",
                passwordPlaceholder: "Phrase eingeben",
                passwordRequired: "Bitte gib ein Passwort für das Event ein.",
                submit: "Event starten",
            },
        },
        openEvents: {
            title: "Offene Events",
            empty: "Aktuell keine offenen Events.",
            joinButton: "Beitreten",
            locationFallback: "Kein Ort",
            startedLabel: "Gestartet {{time}}",
            leaveCurrentFirst: "Verlasse zuerst dein aktuelles Event.",
        },
        accessModal: {
            title: "Event-Zugriff verwalten",
            visibilityLabel: "Sichtbarkeit",
            visibilityRequired: "Wähle eine Sichtbarkeit.",
            passwordLabel: "Zugriffspasswort",
            passwordPlaceholder: "Neues Passwort",
            passwordRequired: "Bitte gib ein Passwort ein.",
            save: "Änderungen speichern",
        },
        passwordModal: {
            title: '"{{event}}" beitreten',
            defaultTitle: "Event beitreten",
            okText: "Beitreten",
            cancelText: "Abbrechen",
            placeholder: "Event-Passwort",
        },
        messages: {
            loadProfileError: "Profildaten konnten nicht geladen werden.",
            loadEventsError: "Events konnten nicht geladen werden.",
            createSuccess: "Event erstellt.",
            createError: "Event konnte nicht erstellt werden.",
            joinSuccess: "Event beigetreten.",
            joinError: "Event konnte nicht beigetreten werden.",
            leaveSuccess: "Event verlassen.",
            leaveError: "Event konnte nicht verlassen werden.",
            endSuccess: "Event beendet.",
            endError: "Event konnte nicht beendet werden.",
            deleteSuccess: "Event gelöscht.",
            deleteError: "Event konnte nicht gelöscht werden.",
            updateAccessSuccess: "Eventzugriff aktualisiert.",
            updateAccessError: "Eventzugriff konnte nicht aktualisiert werden.",
            passwordPromptEmpty: "Bitte gib das Passwort ein.",
            passwordPromptInvalid: "Das Passwort wurde nicht akzeptiert. Bitte versuche es erneut.",
        },
    },
    auth: {
        logoutPendingTitle: "Nicht synchronisierte Getränke verwerfen?",
        logoutPendingDescription_one: "Auf diesem Gerät ist {{count}} Getränk nicht synchronisiert. Wenn du dich abmeldest, wird es dauerhaft verworfen.",
        logoutPendingDescription_other: "Auf diesem Gerät sind {{count}} Getränke nicht synchronisiert. Wenn du dich abmeldest, werden sie dauerhaft verworfen.",
        logoutPendingDiscard: "Abmelden und verwerfen",
        login: "Anmelden",
        logout: "Abmelden",
        password: "Passwort",
        logoutSuccess: "Abgemeldet. Bis bald!",
        logoutError: "Abmeldung fehlgeschlagen. Bitte versuche es erneut.",
        logoutPushOffline: "Verbinde dich mit dem Internet, um dein Erinnerungsabo vor der Abmeldung zu entfernen.",
        ssoIdentityUnavailable: "Deine Anmeldung war erfolgreich, aber Saufdings kann dein Konto derzeit nicht erkennen. Persönliche Funktionen sind deshalb nicht verfügbar.",
        ssoInteractiveFailed: "Die Anmeldung wurde nicht abgeschlossen. Melde dich erneut an.",
    },
    sidebar: {
        dowtexHub: "Dowtex-Portal",
        more: "Mehr",
        brandName: "Saufdings",
        mobileHome: "Start",
        navBeerpong: "Beerpong",
        navKingcup: "Kingcup",
        navShitty: "Shitty",
        navProfile: "Profil",
        navAddDrink: "Getränk hinzufügen",
        navDrinkStats: "Drink-Statistiken",
        navDrinkHistory: "Trinkverlauf",
        navEventStats: "Event-Statistiken",
        openMoreNav: "Weitere Navigation öffnen",
        languageLabel: "Sprache",
        languageEnglish: "Englisch",
        languageGerman: "Deutsch",
        collapse: "Einklappen",
        expand: "Ausklappen",
    },
    installPrompt: {
        title: "Saufdings installieren",
        description: "Füge Saufdings zum Home-Bildschirm hinzu, um die App schnell zu öffnen.",
        install: "Installieren",
        error: "Installation nicht möglich. Bitte versuche es später erneut.",
        iosInstructions: "Tippe auf „Teilen“ und dann auf „Zum Home-Bildschirm“, um Saufdings zu installieren.",
        dismiss: "Installationshinweis schließen",
    },
    addDrink: {
        title: "Getränk hinzufügen",
        subtitle: "Trag ein, was du gerade getrunken hast. Wir kümmern uns um die Statistik.",
        alert: {
            title: "Getränk gespeichert",
            description: "{{amount}} ml {{name}} wurden deiner Statistik hinzugefügt.",
        },
        offline: {
            iosSyncHint: "Öffne Saufdings auf iPhone oder iPad, um vorgemerkte Getränke zu synchronisieren.",
            failedDrink: "{{drink}} konnte nicht synchronisiert werden. Es bleibt auf diesem Gerät gespeichert.",
            retry: "Erneut versuchen",
            remove: "Entfernen",
            title: "Offline",
            description: "Getränke, die du jetzt einträgst, werden auf deinem Gerät gespeichert und gesendet, sobald du wieder online bist.",
            pending: "{{count}} Getränk(e) warten auf Synchronisierung",
            pendingWithFailed: "{{count}} Getränk(e) warten auf Synchronisierung, {{failed}} benötigen Aufmerksamkeit",
            savedDrinkList: "Zeige gespeicherte Getränkeliste",
            noSavedDrinks: "Offline ist keine gespeicherte Getränkeliste verfügbar. Stelle die Verbindung wieder her, um Getränke zu laden.",
        },
        form: {
            drinkLabel: "Getränk",
            drinkPlaceholder: "Getränk auswählen",
            sizeLabel: "Größe",
            customSize: "Eigene",
            implausibleEntry: "Bitte prüfe den Eintrag: Das Volumen liegt über 1,5 l oder die Stärke über 96 % Vol. Prüfe bei selbst gemischten Drinks das eingegebene Volumen und die Stärke.",
            whenLabel: "Wann",
            sizeHelp: "Wähle eine Vorlage, um die Menge automatisch zu setzen. „Eigene“ behält deinen Wert.",
            finishLabel: "Ende des Getränks",
            startLabel: "Startzeit",
            startTooltip: "Wann hast du mit dem Getränk begonnen? Leer lassen, um es aus der Dauer abzuleiten.",
            startCurrent: "Aktuell {{timestamp}}",
            startProvide: "Gib oben eine Endzeit an, um dieses Feld zu aktivieren.",
            durationLabel: "Trinkdauer",
            durationTooltip: "Wie lange hast du an dem Drink genippt?",
            durationCustom: "Eigene Dauer",
            durationHintNoFinish: "Zuerst eine Endzeit wählen, um den Start zu berechnen.",
            durationHintChug: "Als Ex vermerkt – sofort hinzugefügt.",
            durationHintStartAt: "Begonnen etwa um {{timestamp}}",
            durationHintFallback: "Kurz vor der Endzeit begonnen.",
            durationPresetUsed: "Verwende Vorlage {{label}}.",
            durationPresetGeneric: "Verwende vordefinierte Dauer.",
            durationPresetMinutes: "{{minutes}} min",
        },
        amountPresets: {
            shot: "Shot",
            shotSubtitle: "20 ml",
            double: "Doppelter",
            doubleSubtitle: "40 ml",
            longdrink: "Longdrink",
            longdrinkSubtitle: "300 ml",
            beer: "Bier",
            beerSubtitle: "500 ml",
            mass: "Maß",
            massSubtitle: "1 Liter",
            custom: "Eigene Menge",
            customSubtitle: "Beliebige Menge",
        },
        durationPresets: {
            instant: "Ex",
            quarterHour: "15 min",
            halfHour: "30 min",
            threeQuarterHour: "45 min",
            oneHour: "60 min",
        },
        messages: {
            loginToAdd: "Bitte melde dich an, um Drinks hinzuzufügen.",
            selectDrink: "Wähle das Getränk aus, das du getrunken hast.",
            drinkNotFound: "Getränk nicht gefunden. Versuch es erneut.",
            invalidAmount: "Die Menge muss mindestens 1 ml betragen.",
            loginFirst: "Bitte melde dich zuerst an.",
        },
        notifications: {
            drinkRecorded: "Getränk gespeichert. Prost!",
            drinkQueued: "Getränk lokal gespeichert - wird synchronisiert, sobald du wieder online bist. Prost!",
        },
        errors: {
            loadDrinks: "Getränke konnten nicht geladen werden.",
            addDrink: "Getränk konnte nicht gespeichert werden.",
            removeDrink: "Getränk konnte nicht entfernt werden.",
        },
        quickAdd: {
            removeOffline: "Stelle die Internetverbindung wieder her, um dieses Getränk zu löschen.",
            hint: "Einmal tippen, um es einzutragen",
            loading: "Letzte Getränke werden geladen",
            empty: "Zuletzt getrunkene Getränke erscheinen hier.",
            uses: "{{count}}× eingetragen",
            removeButton: "{{drink}} {{amount}} ml entfernen",
            title: "Zuletzt getrunken",
            undo: "Rückgängig",
            durationChug: " · Ex",
            durationApprox: " · ~{{minutes}} min",
            buttonLabel: "+ {{drink}} ({{amount}} ml, {{count}}{{duration}})",
            unavailable: "{{drinkName}} ist nicht mehr verfügbar.",
            added: "{{drinkName}} hinzugefügt.",
            addedQueued: "{{drinkName}} lokal gespeichert - wird synchronisiert, sobald du wieder online bist.",
            removed: "{{drinkName}} entfernt.",
            alreadySynced: "{{drinkName}} wurde bereits synchronisiert. Entferne es bei Bedarf aus deinen letzten Getränken.",
            noRecent: "Kein aktuelles {{drinkName}} zum Löschen gefunden.",
        },
        when: {
            now: "Jetzt",
            "15": "Vor 15 Min.",
            "30": "Vor 30 Min.",
            custom: "Eigene Zeit",
        },
        summary: {
            chooseDrink: "Getränk auswählen",
            line: "{{drink}}, {{amount}} ml, {{when}} · {{duration}}",
        },
        close: "Getränkeingabe schließen",
        submitLabel: "Getränk hinzufügen",
        loginRequiredTitle: "Anmeldung erforderlich",
        loginRequiredDescription: "Melde dich an, um deine Getränke zu verfolgen.",
        modalTitle: "Getränk hinzufügen",
    },
    pages: {
        drinkhelper: {
            title: "Trinkspiele",
            subtitleLine1: "Du willst trinken, weißt aber nicht welches Spiel?",
            subtitleLine2: "Keine Sorge, ich habe etwas für dich.",
            subtitle: "Wählt eure Gruppe und findet euer nächstes Spiel.",
            question: "Wie viele Spieler seid ihr?",
            suggestions: "Spiele für eure Gruppe",
            empty: "Für diese Gruppengröße gibt es noch keine Spiele. Wähle eine andere Anzahl.",
            loading: "Spiele werden geladen",
            gameHint: "Ein schnelles Partyspiel für den Einstieg.",
            hints: { single: "Eine Runde allein", double: "Nur zu zweit", party: "Die ganze Gruppe ist dabei" },
            gameDescriptions: {
                vrchat: "Löst schnelle Challenges in einer gemeinsamen VR-Welt.",
                greekTemple: "Baut in mehreren Runden gemeinsam einen Tempel.",
                laughfools: "Versucht bei albernen Aufgaben ernst zu bleiben.",
                holzfaellern: "Messt euch in einem spielerischen Kraft- und Timingtest.",
                dontDrinkAndDrive: "Beantwortet schnelle Fragen und gebt die Runde weiter.",
                quizzduell: "Fordert euch zu einem schnellen Quizduell heraus.",
                busfahren: "Spielt euch durch eine Reihe spannender Kartenrunden.",
                rideTheBus: "Erratet Karten in einem bekannten Partyspiel.",
                hawaii: "Spielt reihum entspannte Party-Challenges.",
                rageCage: "Werft den Ball schneller als die nächste Person in einen Becher.",
                lieing: "Blufft mit Würfeln und entlarvt die Lüge.",
                shitty: "Gebt die Karten weiter und meidet die Pechkarte.",
                kingcup: "Zieht Karten und spielt auf den letzten König hin.",
                flunky: "Werft im Team, um das Ziel zu treffen.",
                horseRaising: "Lasst euer Pferd in schnellen Runden um den Sieg rennen.",
                iti: "Eine schnelle Party-Challenge mit mutigen Antworten.",
                itiPussy: "Die frechere Variante der schnellen Iti-Challenge.",
            },
            players: {
                single: "1 Spieler",
                double: "2 Spieler",
                party: "3 Spieler oder mehr",
            },
        },
        saufAlone: {
            title: "Sauf Alone",
        },
        saufTwo: {
            title: "Sauf Two",
        },
        saufFriends: {
            title: "Sauf With Your Friends",
        },
        music: {
            title: "Genieß die Musik",
            loading: "Spotify-Playlist wird geladen …",
            spotifyTitle: "Spotify-Playlist",
            spotifyNotice: "Beim Laden des Players wird eine Verbindung zu Spotify hergestellt und deine IP-Adresse übermittelt.",
            loadSpotify: "Spotify-Player laden",
        },
    },
    games: {
        names: {
            higherOrLower: "Höher oder niedriger",
            vrchat: "VRChat",
            greekTemple: "Griechischer Tempel",
            beerpong: "Beerpong",
            laughfools: "Laughfools",
            holzfaellern: "Holzfällern",
            dontDrinkAndDrive: "Don't drink and drive",
            quizzduell: "Quizduell",
            busfahren: "Busfahren",
            rideTheBus: "Ride the bus",
            hawaii: "Hawaii",
            rageCage: "Rage Cage",
            lieing: "Lieing",
            shitty: "Shitty",
            kingcup: "Kingcup",
            flunky: "Flunky Ball",
            horseRaising: "Horse Raising",
            iti: "Iti",
            itiPussy: "Iti Pussy-Version",
        },
        details: {
            higherOrLower: {
                title: "Höher oder niedriger",
                tagline: "Das einfache Kartenspiel",
                description: "Versuch dein Glück: Sag die nächste Karte voraus! Schnell gespielt, leicht erklärt – ein Party-Klassiker.",
                requirementsTitle: "Benötigt wird",
                requirements: ["Ein Kartendeck", "Getränke für alle"],
                instructionsTitle: "So wird gespielt",
                instructions: [
                    "Jede Person zieht eine Karte vom Stapel.",
                    "Bist du dran, sagst du voraus, ob die nächste Karte höher oder niedriger ist.",
                    "Richtig geraten? Gib einen Shot ab. Falsch geraten? Trink selbst einen!",
                ],
                summary: "Rate weiter, solange die Karten für dich laufen – sonst wird getrunken.",
            },
            beerpong: {
                description: "Ein schnelles Duell mit Bechern: Trefft die Becher des gegnerischen Teams.",
                tournamentTitle: "Organisiere dein Beer-Pong-Turnier",
                tournamentDescription:
                    "Bereit für das nächste Level? Mit dem Turnier-Manager erstellst du Brackets, behältst Ergebnisse im Blick und führst Teams durch Gewinner- und Verliererrunden.",
                tournamentNote: "Ps: Nur der Ersteller des Turniers kann Paarungen ändern, Sieger weiterziehen oder den Plan schließen.",
                tournamentButton: "Turnier-Manager öffnen",
                rules: {
                    heading: "Beer-Pong-Regeln",
                    intro: "Legt euch auf das Regelwerk fest, bevor der erste Ball fliegt.",
                    visibleSets: "Sichtbare Regelsets:",
                    empty: "Keine Regeln in diesem Set.",
                    noMatches: "Keine Regeln passen zu den aktuellen Filtern.",
                    offlineTitle: "Offline - zeige gespeicherte Regeln",
                    offlineDescription: "Das sind die Regeln von deiner letzten erfolgreichen Synchronisierung, nicht live.",
                    savedTag: "Gespeichert {{when}}",
                },
                rulesError: "Beer-Pong-Regeln konnten nicht geladen werden.",
                event: {
                    loading: "Turnierdaten werden geladen …",
                },
            },
            busfahren: {
                title: "Ride the Bus – Regeln",
                tagline: "Klassisches Trinkspiel",
                requirementsTitle: "Benötigt wird",
                requirements: ["Ein Kartendeck ohne Joker", "Getränke für alle Mitspielenden"],
                instructionsTitle: "So wird gespielt",
                instructions: [
                    "Zieht reihum Karten und ratet Rot oder Schwarz, höher oder niedriger, dazwischen oder außerhalb sowie die Kartenfarbe.",
                    "Legt die aufgedeckten Karten als Pyramide (5-4-3-2-1). Mit passenden Karten verteilt ihr Getränke entsprechend der Reihe.",
                    "Wer die meisten Karten hat, fährt den Bus und rät bei fünf Karten nacheinander höher oder niedriger.",
                    "Jeder Fehler kostet einen Schluck. Nach einer fehlerfreien Runde darf der Busfahrer die Aufgabe weitergeben.",
                ],
                summary: "Legt vor dem Start eure regionalen Regeln fest.",
                description:
                    "Ride the Bus wird mit einem kompletten Kartendeck gespielt. Wer in den Runden die meisten Fehler macht, muss „den Bus fahren“ – und trinken!",
                variant: "🌍 Variante: Regeln unterscheiden sich je nach Region. Legt eure Variante vor dem Start fest!",
                steps: {
                    setup: {
                        title: "Setup",
                        summary: "Misch das Deck, alle sitzen im Kreis.",
                        detail: [
                            "Ihr braucht ein Kartendeck ohne Joker. Alle setzen sich an einen Tisch oder in einen Kreis – und es kann losgehen.",
                        ],
                        list: [],
                        tip: "",
                    },
                    roundOne: {
                        title: "Runde 1: Kartenstapel",
                        summary: "Alle ziehen reihum Karten und raten.",
                        detail: ["Zieht nacheinander Karten und beantwortet folgende Fragen:"],
                        list: [
                            "Rot oder Schwarz?",
                            "Höher oder niedriger als die letzte Karte?",
                            "Dazwischen oder außerhalb?",
                            "Welche Farbe? Herz, Karo, Pik oder Kreuz?",
                        ],
                        tip: "Tipp: Jeder Fehler = ein Schluck!",
                    },
                    roundTwo: {
                        title: "Runde 2: Die Pyramide",
                        summary: "Pyramide legen, passende Karten bedeuten Getränke.",
                        detail: [
                            "Legt die aufgedeckten Karten als Pyramide (5-4-3-2-1). Hast du dieselbe Karte auf der Hand, darfst du Getränke verteilen:",
                        ],
                        list: ["Reihe mit 5 Karten: 1 Schluck", "Reihe mit 4 Karten: 2 Schluck", "Reihe mit 3 Karten: 3 Schluck", "… und so weiter."],
                        tip: "",
                    },
                    finale: {
                        title: "Finale: Der Busfahrer",
                        summary: "Die meisten Karten? Du fährst den Bus!",
                        detail: [
                            "Die Person mit den meisten Karten wird Busfahrer. Es werden 5 Karten nacheinander aufgedeckt – jedes Mal höher oder niedriger tippen.",
                        ],
                        list: [],
                        tip: "Jeder Fehler kostet einen Schluck! Wer fehlerfrei bleibt, darf abgeben.",
                    },
                },
            },
            dontDrinkAndDrive: {
                title: "Don't Drink and Drive",
                tagline: "Party-Racing-Challenge",
                instructionsTitle: "So wird gespielt",
                instructions: [
                    "Sammelt alle Mitspielenden und startet das Rennspiel.",
                    "Fahrt ein Rennen und trinkt dabei. Fahrt zum Trinken an den Streckenrand; niemals gleichzeitig trinken und fahren.",
                    "Wer Rennen und Drink zuerst beendet, gewinnt. Die letzte Person bekommt eine gemeinsam festgelegte Strafe.",
                ],
                summary: "Auch auf der virtuellen Strecke gilt: Trinken und Fahren bleiben getrennt.",
                description:
                    "Kombiniere Rennspiele und Drinks für eine urkomische Herausforderung, bei der es auf Skill, Tempo und ein bisschen Taktik ankommt. Aber: Sicherheit geht vor – auch auf der virtuellen Strecke!",
                requirementsTitle: "Benötigt wird",
                requirements: ["Getränke", "Eine Konsole mit Rennspiel (am besten Mario Kart)"],
                ruleInstruction: "Jedes Mal, wenn du trinken willst, musst du rechts ranfahren.",
                steps: [
                    {
                        title: "Bereit machen",
                        description: "Alle Mitspieler sammeln und das Rennspiel starten.",
                    },
                    {
                        title: "Die Challenge",
                        description:
                            "Alle fahren ein Rennen. Ziel: Drink und Rennen so schnell wie möglich beenden.",
                        ruleTitle: "Wichtige Regel:",
                        ruleHint: "Nie gleichzeitig trinken und fahren!",
                    },
                    {
                        title: "Sieger & Strafe",
                        description:
                            "Wer Race und Drink zuerst beendet, gewinnt. Der langsamste Spieler bekommt eine witzige Strafe – gemeinsam festlegen.",
                    },
                ],
                warning: "🚦 Denk dran: Es ist nur ein Spiel – im echten Leben nie trinken und fahren!",
            },
            flunky: {
                title: "Flunky Ball",
                tagline: "Outdoor-Spaß",
                description: "Ein actionreiches Outdoor-Spiel für größere Gruppen – ideal für Partys oder Sommertreffen.",
                requirementsTitle: "Benötigt wird",
                requirements: ["Ein Ball pro Team", "Eine Flasche Bier pro Spieler", "Eine große Freifläche"],
                instructionsTitle: "So wird gespielt",
                instructions: [
                    "Teilnehmer in zwei Teams aufteilen, jedes Team hat eine eigene Flasche.",
                    "Eine Flasche steht in der Mitte. Triff die Flasche des Gegners – fällt sie um, trinkt der Spieler einen Strafschluck.",
                    "Trifft dein Team die Flasche in der Mitte, dürft ihr trinken. Prost!",
                    "Sobald die Flasche wieder steht und alle hinter ihren Flaschen sind, muss das andere Team aufhören zu trinken. Wer seine Getränke zuerst leert, gewinnt.",
                ],
                    summary:
                    "Flunky Ball verlangt Koordination und Reaktion. Teams versuchen, Flaschen umzuschießen, sprinten los und trinken, wenn ihre Flasche fällt – perfekt für große Gruppen!",
            },
            hawaii: {
                title: "Hawaii",
                tagline: "Kreatives Deckelspiel",
                description: "Schnippt Kronkorken über ein selbst gezeichnetes Spielfeld mit Inseln und Sonderregeln.",
                requirementsTitle: "Benötigt wird",
                requirements: ["Eine glatte Fläche und etwas zum Draufmalen", "Ein Stift", "Eine Flasche", "Kronkorken"],
                instructionsTitle: "So wird gespielt",
                instructions: [
                    "Stellt eine Flasche auf und zeichnet zwei sich berührende Kreise darum: Hawaii. Alle zeichnen eine Insel mit ihrem Namen.",
                    "Schnippt reihum einen Kronkorken aufs Spielfeld.",
                    "Landet er auf einer Insel, trinkt deren Besitzer. Landet er auf Hawaii, trinken alle.",
                    "Geht der Kronkorken daneben, zeichnet ihr eine kleinere Insel und denkt euch dafür eine Regel aus.",
                    "Gebt den Zug weiter und spielt, bis das Feld voll ist oder ihr aufhören wollt.",
                    "Optionale Variante: Verbindet zwei Inseln, dann gelten beide Regeln gleichzeitig.",
                ],
                summary: "Erfindet gemeinsam Inselregeln und gebt den Zug reihum weiter.",
                setup: {
                    title: "Aufbau",
                    line1: "Schnapp dir etwas zum Draufmalen (Pizza-Karton eignet sich super) und einen Stift.",
                    line2: "Stell eine Flasche in die Mitte und zeichne zwei sich berührende Kreise – das ist dein Hawaii!",
                    line3: "Jeder zeichnet seine eigene Insel (Kreis) und schreibt den Namen hinein.",
                },
                rulesTitle: "Spielablauf",
                rules: {
                    flick: "Der erste Spieler schnippt einen Kronkorken aufs Feld.",
                    hitIsland: {
                        question: "Triffst du eine Insel?",
                        answer: "Der Besitzer trinkt!",
                    },
                    hitHawaii: "Triffst du Hawaii?",
                    everyoneDrinks: "Alle trinken!",
                    miss: {
                        question: "Daneben?",
                        answer:
                            "Zeichne irgendwo einen neuen, kleineren Kreis und erfinde eine Sonderregel. Wird er getroffen, gilt diese Regel.",
                    },
                    rotate: "Der Zug wandert weiter. Spielt, bis das Feld voll ist oder ihr aufhört.",
                    twist: {
                        title: "Optionale Variante:",
                        description: "Zwei Inseln zu einer verbinden – dann gelten beide Regeln gleichzeitig.",
                    },
                },
                exampleTitle: "Beispiel",
                exampleAlt: "Hawaii-Aufbau",
                tip: {
                    title: "Tipp:",
                    text: "Je verrückter die Insel-Regeln, desto besser!",
                },
                footer:
                    "Werdet kreativ: Die Inseln dürfen albern oder gemein sein – ergänzt sie gern, um weitere Spiele einzubauen.",
            },
            holzfaellern: {
                title: "Holzfällern",
                tagline: "Kronkorken-Action",
                description: "Ein Klassiker für Partys – schnell aufgebaut und voller freundschaftlicher Rivalität. Am besten 1 gegen 1, funktioniert aber auch mit mehreren.",
                requirementsTitle: "Benötigt wird",
                requirements: ["Eine Flasche pro Spieler", "Mindestens ein Kronkorken mehr als Spieler"],
                instructionsTitle: "So wird gespielt",
                instructions: [
                    "Setzt euch gegenüber (meist auf den Boden), ungefähr zwei Fußlängen Abstand.",
                    "Stell deine Flasche zwischen die Beine, damit sie stabil steht.",
                    "Lege einen Kronkorken (auf dem Kopf) oben auf die Flasche.",
                    "Werfe reihum Kronkorken auf die Flaschen der Gegner, um deren Deckel herunterzuschießen.",
                ],
                summary:
                    "Ziel: den Kronkorken des Gegners abschießen – dann trinkt er. Legt vorher fest, wie viele Treffer jemand kassieren darf, bevor die Flasche geleert wird.",
            },
            horseRaising: {
                title: "Horse Raising (Kartenversion)",
                tagline: "Karten- & Trinkspiel",
                description:
                    "Aces sind Pferde, der Tisch ist die Rennbahn. Setze auf dein Pferd und hoffe, dass es als erstes durchs Ziel geht!",
                requirementsTitle: "Benötigt wird",
                requirements: [
                    "Ein Kartendeck (mit Assen als Pferde)",
                    "Eine flache Fläche als Rennbahn",
                    "Getränke für alle Spieler",
                ],
                instructionsTitle: "So wird gespielt",
                instructions: [
                    "Mische das Deck und lege vier Karten verdeckt in einer Reihe aus – das ist die Strecke.",
                    "Jede Farbe (Herz, Karo, Pik, Kreuz) ist ein Pferd, das Ass steht am Start.",
                    "Alle setzen Schlücke auf ein Pferd. Richtig getippt? Die Drinks zählen doppelt und können verteilt werden. Falsch? Einsatz verloren.",
                    "Ziehe Karten vom Stapel. Haben alle Pferde einen Streckenabschnitt passiert, wird die Karte aufgedeckt und das passende Pferd rückt zurück.",
                    "Das erste Pferd, das alle Abschnitte überquert, gewinnt. Wer auf dieses Pferd gesetzt hat, darf andere trinken lassen.",
                ],
                summary:
                    "Schnell, chaotisch und spannend – feuert euer Pferd an und hofft auf das richtige Blatt.",
            },
            greekTemple: {
                title: "Griechischer Tempel",
                tagline: "Kartenspiel für Götter",
                description: "Baut drei Kartensäulen, indem ihr voraussagt, ob die nächste Karte höher oder niedriger ist.",
                requirementsTitle: "Benötigt wird",
                requirements: ["Ein Kartendeck", "Getränke für eingestürzte Säulen"],
                instructionsTitle: "So wird gespielt",
                instructions: [
                    "Mischt das Deck und legt drei Karten offen als Säulen aus.",
                    "Lege in deinem Zug je eine Karte an ein Ende jeder Säule und rate vorher höher oder niedriger.",
                    "Bei einer richtigen Antwort bleibt die Karte liegen. Bei einem Fehler stürzt die Säule ein und ihre Karten kommen zurück ins Deck.",
                    "Setzt die Säulen zurück, wenn alle scheitern oder die Karten ausgehen. Jede eingestürzte Säule kostet einen Shot.",
                ],
                summary: "Versucht, alle drei Säulen so lange wie möglich stehen zu lassen.",
                steps: {
                    setup: {
                        title: "Setup",
                        description: "Bereitet Tisch und Deck vor.",
                    },
                    turns: {
                        title: "Spielzüge",
                        description: "So läuft eine Runde.",
                    },
                    next: {
                        title: "Nächste Spieler",
                        description: "Was passiert nach Erfolg oder Fail.",
                    },
                    reset: {
                        title: "Reset & Endgame",
                        description: "Wie der Tempel neu startet.",
                    },
                },
                setup: {
                    heading: "Setup:",
                    line1: "Mische das Deck und lege drei Karten offen nebeneinander – die Säulen.",
                    line2: "Jede Säule ist eine Tempelsäule. Spieler legen Karten an den Enden an.",
                    footer: "Das Fundament steht – baut euren Tempel auf!",
                },
                turns: {
                    line1: "Lege in deinem Zug je eine Karte pro Säule an. Oben oder unten.",
                    line2: "Vorher raten:",
                    higher: "höher",
                    lower: "niedriger",
                    or: "oder",
                    pillar: "Säule {{id}}",
                    prompt: "Rate: höher oder niedriger?",
                    correct: "Richtig geraten? Karte bleibt, weiter zur nächsten Säule.",
                    wrong: "Falsch? Säule stürzt ein, Karten zurück ins Deck.",
                },
                next: {
                    line1: "Je weiter ihr kommt, desto mehr Karten hat jede Säule.",
                    line2: "Nächster Spieler wählt wieder ein Ende und rät höher/niedriger.",
                    collapse: "Bricht eine Säule ein, startet sie mit einer Karte neu.",
                    goal: "🏛 Ziel: alle drei Säulen überleben!",
                    drink: "🍻 Regel: Jede gestürzte Säule = 1 Shot. Alle drei? 3 Shots und Neustart.",
                },
                reset: {
                    line1: "Wenn alle scheitern oder Karten fehlen, mischt neu und setzt die Säulen zurück.",
                    line2: "Spielt so lange ihr wollt – zählt erfolgreiche Runden oder trinkt einfach weiter.",
                    footer: "🥂 Der Tempel mag fallen, der Pegel nicht.",
                },
            },
            kingCup: {
                title: "King’s Cup Regeln",
                tagline: "Let’s fckng do it – whoop whoop!",
                description:
                    "Zieht Karten aus dem Kreis. Wer den Ring bricht, kippt – je nach Hausregel – den King’s Cup oder das eigene Getränk.",
                requirementsTitle: "Benötigt",
                requirements: ["Ein Kartendeck", "Ein zentraler Becher und Getränke"],
                instructionsTitle: "So wird gespielt",
                instructions: ["Zieh eine Karte aus dem Kreis und befolge die Regel dieser Karte."],
                summary: "🍻 Tipp: Denk dir eine Regel aus, bevor du sie brauchst. „Schurik trinkt immer“ funktioniert, könnte aber auf dich zurückfallen.",
                hint: "🍻 Tipp: Denk dir eine Regel aus, bevor du sie brauchst. „Schurik trinkt immer“ funktioniert, könnte aber auf dich zurückfallen.",
                cards: {
                    king: {
                        label: "König",
                        rule: "Der Herrscher",
                        description: "Erfinde eine Regel und trink so viele Schlücke, wie Könige gezogen wurden. Der letzte König leert den Becher.",
                    },
                    queen: {
                        label: "Dame",
                        rule: "Fragenmeister",
                        description: "Stell Fragen – wer antwortet, trinkt. (Spielantworten zählen nicht.)",
                    },
                    jack: {
                        label: "Bube",
                        rule: "Ich hab noch nie",
                        description: "Sag etwas, das du nie getan hast. Alle, die es getan haben, trinken.",
                    },
                    ten: {
                        label: "10",
                        rule: "Ten is Men",
                        description: "Jungs trinken.",
                    },
                    nine: {
                        label: "9",
                        rule: "Nine is Rhyme",
                        description: "Starte einen Reim – wer scheitert oder wiederholt, trinkt.",
                    },
                    eight: {
                        label: "8",
                        rule: "Eight is Mate",
                        description: "Suche dir einen Trinkpartner, der immer mit dir trinkt (bis zur nächsten 8).",
                    },
                    seven: {
                        label: "7",
                        rule: "Seven to Heaven",
                        description: "Zeig spontan nach oben. Der Letzte trinkt. (Wechselt mit jeder 7.)",
                    },
                    six: {
                        label: "6",
                        rule: "Six is Chicks",
                        description: "Alle Frauen trinken.",
                    },
                    five: {
                        label: "5",
                        rule: "Kategorien",
                        description: "Nenne eine Kategorie (z. B. Automarken). Wer wiederholt oder nichts mehr weiß, trinkt.",
                    },
                    four: {
                        label: "4",
                        rule: "Four You",
                        description: "Bestimme jemanden, der trinken muss.",
                    },
                    three: {
                        label: "3",
                        rule: "Three for Me",
                        description: "Du trinkst selbst.",
                    },
                    two: {
                        label: "2",
                        rule: "Double Down",
                        description: "Ab jetzt zählen deine Drinks doppelt, bis die nächste 2 erscheint.",
                    },
                    ace: {
                        label: "Ass",
                        rule: "Waterfall",
                        description: "Alle trinken so lange wie der Spieler mit dem Ass.",
                    },
                },
            },
            shitty: {
                title: "Shitty",
                tagline: "Spiel zum Vollwerden",
                description: "Ein Kartenspiel mit schnellen Vorhersagen, steigenden Einsätzen und einem gemeinsamen Finale.",
                requirementsTitle: "Benötigt",
                requirements: ["Ein Kartendeck", "Mindestens zwei Spieler"],
                instructionsTitle: "So wird gespielt",
                instructions: [
                    "Sagt Rot oder Schwarz, niedriger oder höher, dazwischen oder außerhalb und dann die Kartenfarbe voraus.",
                    "Sobald alle vier Karten haben, beendet eine passende Karte aus dem Kartenkranz die Runde für alle.",
                    "Legt neun Karten fürs Finale aus. Gleiche Werte folgen dem Multiplikator der guten oder bösen Reihe; alle trinken den Wert der letzten Karte.",
                ],
                summary: "Trefft die Kartenvorhersagen und beendet das Spiel mit den guten und bösen Reihen.",
                steps: {
                    decision: {
                        title: "Entscheidungsrunden",
                        description: "Rot oder Schwarz? Höher oder niedriger?",
                    },
                    endgame: {
                        title: "Finale",
                        description: "Letzte Runde mit Layout und Regeln.",
                    },
                },
                decision: {
                    heading: "Entscheidungsrunde",
                    cards: {
                        redBlack: {
                            title: "Rot oder Schwarz?",
                            win: "Gib einen Shot an eine andere Person.",
                            lose: "Trink selbst einen Shot.",
                        },
                        underAbove: {
                            title: "Drunter oder drüber? (Oder gleich)",
                            win: "Gib zwei Shots an jemand anderen.",
                            lose: "Trink zwei Shots selbst.",
                        },
                        betweenOutside: {
                            title: "Dazwischen oder außen?",
                            win: "Gib einen Shot an jemand anderen.",
                            lose: "Trink einen Shot selbst.",
                        },
                        sameSuit: {
                            title: "Gleiche Farbe?",
                            win: "Gib drei Shots an jemand anderen.",
                            lose: "Trink drei Shots selbst.",
                        },
                    },
                    progressive: {
                        title: "Progressive Entscheidung",
                        description1:
                            "Sobald alle vier Karten haben, gibt es den Zusatz: Hast du dieselbe Karte wie im Kreis, wirf sie in die Mitte.",
                        description2: "Damit endet die Runde für alle!",
                        win: "Passende Karte? Verteile fünf Schlücke.",
                        lose: "Keine passende Karte? Trink fünf Schlücke selbst.",
                        hint: "🍻 Tipp: Ein Regenbogen (jede Farbe) verdoppelt den Spaß.",
                    },
                },
                endgame: {
                    heading: "Finale",
                    layoutLine1: "Legt neun Karten wie gezeigt aus.",
                    layoutLine2: "Obere Reihe „Gut“, untere Reihe „Böse“ – der Multiplikator entscheidet, wer trinkt.",
                    backgroundAlt: "Hintergrundkarte",
                    paragraphs: [
                        "Dreht Karten um; wer dieselbe Zahl hat, legt sie auf die Reihe.",
                        "Gute Reihe: Verteile Getränke mit dem Karten-Multiplikator.",
                        "Böse Reihe: Trink selbst – ebenfalls mit Multiplikator.",
                        "Die letzte Karte wird umgedreht und alle trinken ihren Kartenwert.",
                    ],
                },
            },
            iti: {
                title: "Iti (Card Slap Game)",
                tagline: "Reaktions- & Trinkspiel",
                description: "Schnelles Schnippspiel. Karten abwerfen, richtig zuschlagen und nicht zu spät – sonst trinkst du.",
                requirementsTitle: "Benötigt wird",
                requirements: ["Ein Kartendeck", "Mindestens 2 Spieler", "Ein Tisch zum Klatschen"],
                instructionsTitle: "So wird gespielt",
                instructions: [
                    "Karten gleichmäßig verteilen, Stapel verdeckt lassen.",
                    "Reihum Karte auf einen gemeinsamen Stapel legen.",
                    "Liegt eine Karte doppelt, klatschen die betroffenen Spieler auf den Tisch.",
                    "Wer zu spät oder falsch klatscht, nimmt alle offenen Karten – und trinkt.",
                ],
                summary:
                    "Wer zuerst alle Karten loswird, gewinnt. Schnelle Reaktionen sparen dich vor Zusatzkarten und Schlücken.",
            },
            itiSequential: {
                title: "Iti (Sequential Card Slap Game)",
                tagline: "Reaktions- & Trinkspiel",
                description:
                    "Variante mit Reihenfolge. Karten korrekt ansagen, schnell klatschen – letzter nimmt den Stapel.",
                requirementsTitle: "Benötigt wird",
                requirements: ["Ein Kartendeck", "Mindestens 2 Spieler", "Ein Tisch zum Klatschen"],
                instructionsTitle: "So wird gespielt",
                instructions: [
                    "Alle Karten liegen verdeckt in der Mitte.",
                    "Karten werden in Reihenfolge (2 bis Ass) gespielt, danach wieder bei 2 starten.",
                    "Wer die richtige Karte ansagt und legt, löst ein Klatschen aus.",
                    "Letzter beim Klatschen oder falsche Karte? Stapel einstecken und trinken.",
                ],
                summary:
                    "Ordnung merken, Tempo halten, blitzschnell klatschen – sonst gibt’s mehr Karten (und Alkohol).",
            },
            quizzler: {
                title: "Quizzler",
                tagline: "What Dafuq Is Going On",
                description: "Beantwortet abwechselnd Fragen aus dem Allgemeinwissen in einem schnellen Quizduell.",
                requirementsTitle: "Benötigt",
                requirements: ["Einen Quizmaster", "Quizfragen"],
                instructionsTitle: "So wird gespielt",
                instructions: [
                    "Bestimmt einen Quizmaster und bildet Teams oder spielt allein.",
                    "Der Quizmaster stellt Fragen aus dem Allgemeinwissen.",
                    "Falsche Antwort? Trinken!",
                    "Richtige Antwort? Die anderen trinken oder die Gewinnerperson erfindet eine neue Regel.",
                ],
                summary: "Nutzt Quizfragen aus dem Netz, Karten oder eigene Fragen – je kreativer, desto besser.",
                steps: {
                    pick: "Quizmaster wählen, Teams bilden oder solo spielen.",
                    ask: "Quizmaster stellt Wissenfragen aller Art.",
                    wrong: "Falsche Antwort? Trinken!",
                    right: "Richtige Antwort? Die anderen trinken – oder du erfindest eine neue Regel.",
                },
                extra: "Fragen aus dem Netz, Karten oder eigene Fragen – je kreativer, desto besser.",
                tip: "Tipp: Macht’s persönlich oder thematisch. Der Quizmaster hat immer Recht!",
            },
            laughfools: {
                title: "Laughfool",
                tagline: "Die Nicht-Lachen-Challenge",
                description: "Versuch ernst zu bleiben! Wer lacht, verliert – und trinkt. Perfekt für jede Runde mit Humor.",
                requirementsTitle: "Benötigt",
                requirements: [
                    "Ein Gerät, um Witze nachzuschlagen (Handy, Tablet, …)",
                    "Eine Truppe, die lachen will",
                    "Getränke nach Wahl",
                ],
                howToTitle: "So wird gespielt",
                steps: [
                    "Alle erzählen reihum Witze.",
                    "Wer lacht, muss trinken.",
                    "Mehr Würze gefällig? Schaut gemeinsam ein lustiges Video – wer lacht, trinkt.",
                ],
                instructionsTitle: "So wird gespielt",
                instructions: [
                    "Alle erzählen reihum Witze.",
                    "Wer lacht, muss trinken.",
                    "Mehr Würze gefällig? Schaut gemeinsam ein lustiges Video – wer lacht, trinkt.",
                ],
                summary: "😁 Hältst du dich zurück oder bist du der erste Laughfool?",
                restrictionsTitle: "Optionale Regeln/Varianten",
                restrictions: [
                    "Jokelänge begrenzen (nur kurz oder Mindestlänge).",
                    "Kategorien festlegen: familienfreundlich, schwarz, dirty, thematisch, …",
                ],
                footer: "😁 Hältst du dich zurück oder bist du der erste Laughfool?",
            },
            rageCage: {
                title: "Rage Cage",
                tagline: "Gas-Gas-GasGasGasGas",
                description: "Schnell, laut und kompetitiv. Entweder mithalten oder austrinken! 🍻",
                requirementsTitle: "Benötigt",
                requirements: [
                    "Einige Becher (mindestens 10)",
                    "Mindestens zwei Ping-Pong-Bälle",
                    "Einen Tisch",
                ],
                instructionsTitle: "So wird gespielt",
                instructions: [
                    "Zwei gegenüber sitzende Personen nehmen je einen Becher, stoßen an und trinken.",
                    "Versucht, den Ball in euren leeren Becher zu tippen.",
                    "Bei einem Treffer gebt ihr Becher und Ball nach rechts weiter; beim ersten Versuch dürft ihr an beliebige Personen weitergeben.",
                    "Stehen Becher vor einer Person in einer Reihe, stapelt sie. Diese Person nimmt einen frischen Becher aus der Mitte und holt auf.",
                    "Trefft ihr einen Becher in der Mitte, trinkt ihn.",
                ],
                summary: "Festgefahren? Tempo hochhalten – Langsamkeit wird weggeext!",
                setupTitle: "Aufbau",
                setupDescription: "Stell alle Becher als Kreis oder Haufen in die Tischmitte.\nFast jede Anordnung funktioniert!",
                setupImages: [
                    { alt: "Rage-Cage-Grundaufbau", caption: "Ein einfacher Startaufbau 👆" },
                    { alt: "Rage-Cage-Wildaufbau", caption: "Werd wild: Shots in manchen Bechern bringen mehr Chaos 🥃" },
                ],
                setupTip: "Tipp: Misch besondere Drinks oder variiere die Füllmenge für extra Spaß!",
                howToTitle: "So läuft es",
                steps: [
                    { title: "Start", description: "Zwei gegenüber sitzende Spieler schnappen sich je einen Becher, stoßen an und trinken." },
                    { title: "Bounce!", description: "Versuch den Ball in deinen leeren Becher zu tippen." },
                    {
                        title: "Weitergeben",
                        description: "Triffst du, gibst du Becher und Ball an deine rechte Nachbarperson.",
                        note: "Erster Versuch sitzt? Du darfst an jede beliebige Person weitergeben.",
                    },
                    {
                        title: "Überholspur",
                        description: "Stapel bilden sich vor jemandem? Staple sie! Die betroffene Person nimmt einen frischen Becher aus der Mitte und holt auf.",
                    },
                    { title: "Becher in der Mitte erwischt?", description: "Trink ihn!" },
                ],
                paceTip: "Festgefahren? Tempo hochhalten – Langsamkeit wird weggeext!",
                footer: "Wenn du vergisst Gas zu geben, finde ich dich …",
            },
            lieingOverview: {
                title: "Lieing-Varianten",
                subtitle: "Dir ist nach Lügen? Such dir dein Gift aus!",
                tagline: "Such dir deinen Bluff aus",
                description: "Wähle die Karten- oder Würfelvariante, um ihre Regeln zu sehen.",
                requirementsTitle: "Wähle eine Variante",
                requirements: ["Karten oder Würfel"],
                instructionsTitle: "Variante wählen",
                instructions: ["Öffne Karten oder Würfel, um die Regeln zu sehen."],
                summary: "Wählt die Version, die ihr spielen möchtet.",
                variants: {
                    cards: {
                        title: "Karten",
                        description: "Alle bekommen Karten und flunkern über ihre Werte.",
                    },
                    cubes: {
                        title: "Würfel",
                        description: "Fordern wir das Glück heraus.",
                    },
                },
            },
            lieingCards: {
                title: "Lügen mit Karten",
                tagline: "Bluff-Kartenspiel",
                description: "Werde deine Karten los, indem du sie in Reihenfolge spielst – oder indem du lügst! Entlarve Blender und lass sie trinken!",
                requirementsTitle: "Benötigt",
                requirements: ["Kartendeck", "Getränke für alle"],
                rulesTitle: "So wird gespielt",
                instructionsTitle: "So wird gespielt",
                instructions: [
                    "Verteilt die Karten gleichmäßig an alle.",
                    "Legt Karten verdeckt auf den Stapel und sagt aufsteigend an, welche Karte es sein soll. Ihr müsst nicht die Wahrheit sagen.",
                    "Ruft cap, um die letzte Ansage anzuzweifeln. War sie gelogen, nimmt der Lügner alle Karten. War sie wahr, nimmt sie der Herausforderer.",
                    "Wer den Stapel nimmt, trinkt.",
                ],
                summary: "Achtung, kann für ordentlich Pegel sorgen und Freundschaften testen …",
                rules: {
                    deal: "Verteilt die Karten gleichmäßig an alle.",
                    declare: "Legt Karten <strong>verdeckt</strong> auf den Stapel und sagt an, welche Karte es sein sollte (aufsteigend). <italic>Ihr müsst nicht die Wahrheit sagen!</italic>",
                    challenge: "Jeder kann <code>cap</code> rufen, um die letzte Ansage zu prüfen. War es gelogen, nimmt der Lügner alle Karten. War es wahr, muss der Herausforderer alles nehmen!",
                    drink: "Wer den Stapel nehmen muss, trinkt.",
                },
                exampleTitle: "Beispiel",
                honestExample: "Ehrliches Spiel sieht so aus:",
                lieExample: "So kann Gelüge aussehen:",
                tooltip: "Ruft jemand <code>cap</code>, wird geprüft, ob die Karte passt. Lügner nehmen alles, sonst der Herausforderer!",
                tooltipTrigger: "Ruf jederzeit <code>cap</code>, um herauszufinden, ob jemand lügt.",
                footer: "Achtung, kann für ordentlich Pegel sorgen und Freundschaften testen …",
            },
            lieingCubes: {
                title: "Lieing Cubes",
                tagline: "Bluff-Würfel (mit zwei Würfeln)",
                description: "Bluffe dich zum Ruhm mit zwei Würfeln. Wer wagt, der trinkt.",
                requirementsTitle: "Benötigt",
                requirements: [
                    "Zwei Würfel",
                    "Einen Becher",
                    "Etwas zum Abdecken (z. B. Karton)",
                ],
                howToTitle: "So wird gespielt",
                instructionsTitle: "So wird gespielt",
                instructions: [
                    "Die erste Person würfelt zwei Würfel verdeckt im Becher.",
                    "Sieht sich den Wurf an und sagt ein beliebiges Ergebnis an – wahr oder gelogen.",
                    "Die nächste Person muss eine höhere Kombination würfeln oder den Bluff anzweifeln.",
                    "Bei einer Lüge trinkt die lügende Person. Bei der Wahrheit trinkt der Herausforderer.",
                ],
                summary: "Für Mutige: Nach jeder Runde Becher weiterreichen und weiterbluffen. Am besten gar nicht erst nachsehen.",
                steps: [
                    {
                        title: "Geheim würfeln",
                        description: "Erste Person würfelt <strong>zwei Würfel</strong> im Becher, abgedeckt mit Karton.",
                    },
                    {
                        title: "Spicken & Bluffen",
                        description: "Spitz auf deinen Wurf. Ruf ein beliebiges Ergebnis – <strong>Wahrheit oder Lüge</strong>!",
                    },
                    {
                        title: "Ansage!",
                        description: "Die nächste Person muss eine <strong>höhere</strong> Kombi würfeln (siehe unten) oder deinen Bluff callen.",
                    },
                    {
                        title: "Aufdecken & Trinken",
                        description: "<underline>Wenn du gelogen hast:</underline> <danger>Du trinkst.</danger>\n<underline>Wenn du die Wahrheit gesagt hast:</underline> <success>Der Herausforderer trinkt!</success>",
                    },
                ],
                rankingsTitle: "Rangliste",
                rankingsIntroTitle: "Was schlägt was?",
                rankingsIntroDescription: "Höhere Kombination schlägt niedrigere!",
                rankingsNote: [
                    "<strong>21</strong> ist die <warning>höchste Kombination</warning> – nichts schlägt sie!",
                    "Behauptet jemand 21, kannst du nur anzweifeln oder selbst versuchen, sie zu würfeln.",
                ],
                footer: "Für Mutige: Nach jeder Runde Becher weiterreichen und weiterbluffen. Am besten gar nicht erst nachsehen.",
            },
        },
    },
    tournamentUi: {
        createTitle: "Turnier erstellen",
        matchDetails: "Matchdetails",
        event: "Event {{id}}",
        chooseEvent: "Wähle zuerst ein aktives Event.",
        pass: "Freilos",
        passHint: "rückt automatisch weiter",
        bracketScrollHint: "Wische horizontal, um die Runden zu sehen.",
        eliminatedEntrants: "Ausgeschiedene Teilnehmer",
        eliminated: "Eliminiert",
        eliminatedRound: "In Runde {{round}} ausgeschieden",
        status: { draft: "Entwurf", running: "Läuft", completed: "Abgeschlossen", cancelled: "Abgebrochen" },
        entrants: { active: "Aktiv", out: "Zurückgezogen", withdraw: "Zurückziehen", reinstate: "Wieder aufnehmen", summary: "{{active}} aktiv, {{out}} zurückgezogen", empty: "Noch keine Teilnehmer." },
    },
    beerpong: {
        tournament: {
            entrants: { active: "Dabei", out: "Eliminiert", eliminate: "Eliminieren", restore: "Wiederherstellen", summary: "{{active}} dabei, {{out}} eliminiert", empty: "Noch keine Teams." },
            backButton: "Beer-Pong-Übersicht",
            title: "Turniermanager",
            sections: {
                setupTitle: "Turnierdetails",
                setupDescription:
                    "Legt euer Bracket fest und tragt die Teams ein. Den Stil könnt ihr später ändern, solange das Turnier läuft.",
                listTitle: "Turniere",
                detailsDrawerTitle: "Turnierdetails",
            },
            signInNotice: "Melde dich an, um Turniere zu speichern und Brackets zu verwalten.",
            searchPlaceholder: "Turniere nach Namen durchsuchen",
            form: {
                title: "Turnier erstellen",
                nameLabel: "Name des Turniers",
                styleLabel: "Turnierformat",
                visibilityLabel: "Sichtbarkeit",
                passwordLabel: "Turnierpasswort",
                teamTitle: "Team {{number}}",
                removeTeam: "Entfernen",
                teamNameLabel: "Teamname",
                participantLabel: "Mitspieler {{number}}",
                removeParticipant: "Entfernen",
                addParticipant: "Mitspieler hinzufügen",
                addTeam: "Team hinzufügen",
                submit: "Turnier starten",
                hintMinTeams: "Mindestens zwei Teams werden benötigt, um ein Turnier zu starten.",
            },
            list: {
                winnerLabel: "Sieger:",
                categories: {
                    active: "Aktive Turniere",
                    completed: "Abgeschlossene Turniere",
                    archived: "Archivierte Turniere",
                },
                empty: {
                    default: "Keine Turniere.",
                    active: "Keine aktiven Turniere.",
                    completed: "Noch keine abgeschlossenen Turniere.",
                    archived: "Keine archivierten Turniere.",
                },
                refresh: "Aktualisieren",
            },
            styles: {
                roundRobin: "Jeder-gegen-jeden",
                singleElimination: "K.-o.-System",
                doubleElimination: "Double-Elimination",
                hybrid: "Hybrid",
            },
            status: {
                active: "Aktiv",
                completed: "Abgeschlossen",
                cancelled: "Abgebrochen",
            },
            visibility: {
                public: "Öffentlich",
                friends: "Nur Freunde",
                password: "Passwortgeschützt",
                private: "Privat",
            },
            messages: {
                signInRequired: "Melde dich an, um ein Turnier zu starten.",
                nameRequired: "Bitte gib einen Turniernamen ein.",
                minTeams: "Es werden mindestens zwei Teams benötigt.",
                teamNeedsParticipant: "Team \"{{team}}\" braucht mindestens einen Mitspieler.",
                passwordRequired: "Bitte setze ein Passwort für das Turnier.",
                loadTournamentsError: "Turniere konnten nicht geladen werden.",
                createSuccess: "Turnier erstellt!",
                byeInfo: "Ein Team hat in Runde eins ein Freilos bekommen. Du kannst Paarungen jederzeit anpassen.",
                createError: "Unerwarteter Fehler beim Erstellen des Turniers.",
                signInToUpdate: "Für diese Aktion musst du angemeldet sein.",
                matchUpdated: "Match aktualisiert.",
                matchPairingUpdated: "Matchpaarung aktualisiert.",
                updateMatchError: "Match konnte nicht aktualisiert werden.",
                tournamentUpdated: "Turnier aktualisiert.",
                updateStatusError: "Turnierstatus konnte nicht aktualisiert werden.",
                styleUpdated: "Turnierstil aktualisiert.",
                styleUpdateError: "Turnierstil konnte nicht aktualisiert werden.",
                accessUpdated: "Zugriffseinstellungen aktualisiert.",
                accessUpdateError: "Zugriffseinstellungen konnten nicht aktualisiert werden.",
                enterPassword: "Gib das Turnierpasswort ein.",
                unlockSuccess: "Turnier entsperrt.",
                unlockError: "Turnier konnte nicht entsperrt werden.",
                teamEliminated: "Team \"{{team}}\" wurde eliminiert.",
                teamEliminateError: "Team konnte nicht eliminiert werden.",
                advanceSuccess: "Nächste Runde generiert.",
                advanceError: "Nächste Runde konnte nicht generiert werden.",
                teamRestored: "Team \"{{team}}\" wurde wiederhergestellt.",
                teamRestoreError: "Team konnte nicht wiederhergestellt werden.",
                deleteSuccess: "Turnier gelöscht.",
                deleteError: "Turnier konnte nicht gelöscht werden.",
            },
            details: {
                empty: "Wähle ein Turnier, um den kompletten Spielplan zu sehen.",
                noParticipants: "Keine Teilnehmer eingetragen.",
                match: {
                    pending: "Ausstehend",
                    teamSlot: "Team {{slot}}",
                    tbd: "Offen",
                    selectTeam: "Team auswählen",
                    winnerTag: "Sieger",
                    eliminatedTag: "Eliminiert",
                    eliminatedRound: "Eliminiert · Runde {{round}}",
                    label: "Match #{{number}}",
                    winnerLabel: "Sieger",
                    cancelledTag: "Abgebrochen",
                    bye: "Freilos: {{team}} rückt automatisch weiter.",
                    pass: "Freilos",
                    passHint: "rückt automatisch weiter",
                },
                conflict: {
                    alsoPlays: "{{team}} spielt in dieser Runde auch {{match}}.",
                    swap: "Tauschen",
                    putsThere: "setzt {{team}} stattdessen dort ein",
                    keepBoth: "Beide behalten",
                    cancel: "Abbrechen",
                    emptySlot: "einen freien Platz",
                },
                status: { active: "Läuft", completed: "Abgeschlossen", cancelled: "Abgebrochen" },
                matches: {
                    empty: "Noch keine Matches geplant.",
                    roundTitle: "Runde {{round}}",
                    compactTitleWithRound: "Match #{{number}} · Runde {{round}}",
                    compactTitle: "Match #{{number}}",
                },
                brackets: {
                    winners: "Winner-Bracket",
                    losers: "Loser-Bracket",
                    finals: "Finale",
                },
                tags: {
                    passwordRequired: "Passwort nötig",
                    managedByYou: "Von dir verwaltet",
                    viewOnly: "Nur Ansicht",
                },
                meta: {
                    createdAt: "Erstellt am {{date}}",
                    creatorOnly: "Nur der Ersteller kann Änderungen vornehmen.",
                },
                actions: {
                    manageAccess: "Zugriff verwalten",
                    generateNextRound: "Nächste Runde erzeugen",
                    complete: "Abschließen",
                    cancel: "Abbrechen",
                    delete: "Löschen",
                    unlock: "Turnier entsperren",
                    restoreTeam: "Team wiederherstellen",
                    eliminateTeam: "Team eliminieren",
                },
                popconfirm: {
                    finishTitle: "Turnier abschließen?",
                    finishDescription: "Markiert das Turnier als abgeschlossen.",
                    cancelTitle: "Turnier abbrechen?",
                    cancelDescription: "Der Verlauf bleibt erhalten, es finden aber keine Matches mehr statt.",
                    deleteTitle: "Turnier löschen?",
                    deleteDescription: "Alle Teams und Matches werden dauerhaft entfernt.",
                    eliminateTitle: "Dieses Team eliminieren?",
                },
                alerts: {
                    passwordTitle: "Passwort nötig",
                    passwordDescription: "Gib das Turnierpasswort ein, um Bracket und Matches zu sehen.",
                },
                forms: {
                    unlockPasswordLabel: "Turnierpasswort",
                    unlockPasswordRule: "Bitte gib das Turnierpasswort ein.",
                    unlockPasswordPlaceholder: "Turnierpasswort",
                    accessModalTitle: "Zugriff auf das Turnier verwalten",
                    accessModalSave: "Änderungen speichern",
                    visibilityLabel: "Sichtbarkeit",
                    visibilityRule: "Wähle eine Sichtbarkeit.",
                    passwordLabel: "Passwort",
                    passwordRule: "Bitte gib ein Passwort ein.",
                    passwordPlaceholder: "Neues Passwort",
                    passwordRemovalNotice: "Beim Entfernen des Passwortschutzes wird das bestehende Passwort gelöscht.",
                },
                roundRobin: {
                    leaders_one: "Round-Robin-Spitzenreiter",
                    leaders_other: "Round-Robin-Spitzenreiter",
                    winners_one: "Round-Robin-Sieger",
                    winners_other: "Round-Robin-Co-Sieger",
                },
                sections: {
                    teams: "Teams",
                    matches: "Matches",
                },
            },
        },
    },
    drinkStats: {
        authRequired: {
            title: "Anmeldung benötigt",
            description: "Melde dich an, um deine Trinkstatistiken und Serien zu sehen.",
        },
        page: {
            title: "Trinkübersicht",
            subtitle:
                "Übersicht für {{date}} (fasst späte Abende zusammen, indem das Zeitfenster rund um deine Session erweitert wird).",
        },
        summary: {
            volumeDay: "Ausgewählter Tag ({{date}})",
            volumeWeek: "7 Tage bis {{date}}",
            volumeMonth: "30 Tage bis {{date}}",
            alcoholDay: "Reiner Alkohol am ausgewählten Tag",
            alcoholWeek: "Reiner Alkohol über 7 Tage",
            alcoholMonth: "Reiner Alkohol über 30 Tage",
            promilleWeek: "Höchste geschätzte Promille über 7 Tage",
            promilleMonth: "Höchste geschätzte Promille über 30 Tage",
        },
        recentDrinks: {
            deleteOffline: "Stelle die Internetverbindung wieder her, um ein Getränk zu löschen.",
            title: "Letzte Drinks",
            refresh: "Aktualisieren",
            edit: "Bearbeiten",
            delete: "Löschen",
            deleteConfirm: "Diesen Eintrag löschen?",
            deleteOk: "Löschen",
            deleteCancel: "Abbrechen",
            noTimestamp: "Kein Zeitstempel",
            entryTitle: "{{drink}} - {{amount}} ml",
            durationChugged: "Ex.",
            durationSimple: "≈{{minutes}} min",
            durationWithStart: "≈{{minutes}} min (gestartet {{time}})",
            empty: "Keine Drinks im Fenster {{date}} erfasst.",
            abvLabel: "{{abv}}% Vol.",
        },
        metabolism: {
            weightLabel: "Dein Gewicht",
            weightHelp: "Dient zur Abschätzung der Promille in der untenstehenden Grafik.",
            sexLabel: "Geschlecht",
            male: "Männlich",
            female: "Weiblich",
            promilleNow: "Geschätzte Promille jetzt",
            promilleSelectedDay: "Höchste geschätzte Promille am ausgewählten Tag",
            implausibleEstimate: "Schätzung unplausibel hoch – prüfe Mengen und Zeiten.",
            breathalyzer: "Alkoholtest ≈ {{mg}} mg/L (Toleranz berücksichtigt). Widmark-Schätzung {{promille}}‰.",
            soberSince: "Nüchtern seit {{time}}",
            soberEta: "Voraussichtlich nüchtern um {{time}}",
        },
        timeline: {
            title: "Geschätzter Promille-Verlauf",
            axisLabel: "Geschätzte Promille",
            tooltipLabel: "Geschätzte Promille",
            empty: "Keine Daten für {{date}} in diesem Trinkfenster.",
            soberAt: "Nüchtern um {{time}}",
            soberEta: "Voraussichtlich nüchtern um {{time}}",
        },
        editModal: {
            title: "Drink-Eintrag bearbeiten",
            save: "Speichern",
            drinkLabel: "Drink auswählen",
            drinkPlaceholder: "Drink auswählen",
            amountLabel: "Menge (ml)",
            finishedLabel: "Beendet um",
            startedLabel: "Gestartet um",
            durationLabel: "Dauer (Minuten)",
            durationSuffix: "min",
            chuggedNote: "Als Ex markiert.",
            startedAround: "Begonnen gegen {{time}}",
        },
        messages: {
            loadActivitiesError: "Drinks konnten nicht geladen werden.",
            loadAvailableError: "Getränkeliste konnte nicht geladen werden.",
            cannotEditYet: "Dieser Eintrag kann noch nicht bearbeitet werden.",
            noDrinksToEdit: "Keine Drinks zum Bearbeiten verfügbar.",
            editNoEntry: "Kein Eintrag ausgewählt.",
            editSelectDrink: "Bitte wähle einen Drink.",
            editSelectFinish: "Bitte gib an, wann der Drink beendet wurde.",
            editAmountMin: "Die Menge muss größer als 0 ml sein.",
            editDrinkUnavailable: "Der ausgewählte Drink ist nicht mehr verfügbar.",
            editSuccess: "Eintrag aktualisiert.",
            editError: "Eintrag konnte nicht aktualisiert werden.",
            loginAgain: "Bitte melde dich erneut an.",
            deleteNotAllowed: "Dieser Eintrag kann nicht gelöscht werden.",
            deleteSuccess: "Eintrag gelöscht.",
            deleteError: "Eintrag konnte nicht gelöscht werden.",
        },
        drinkOptionLabel: "{{drink}} ({{abv}}% Vol.)",
    },
    drinkHistory: {
        summary: { days: "Trinktage", drinks: "Getränke", volume: "Gesamtmenge" },
        actions: { retry: "Erneut versuchen" },
        loading: "Trinkverlauf wird geladen",
        authRequired: {
            title: "Anmeldung benötigt",
            description: "Melde dich an, um deinen Trinkverlauf im Kalender zu sehen.",
        },
        page: {
            title: "Trinkverlauf",
            subtitle: "Durchstöbere deine vergangenen Trinktage im Kalender.",
        },
        calendar: {
            scrollRegion: "Scrollbarer Kalender des Getränkeverlaufs",
            yearLabel: "Jahr",
            monthLabel: "Monat",
            monthMode: "Monatsansicht",
            yearMode: "Jahresansicht",
            badgeTooltip: "{{count}} Einträge · {{amount}} ml",
        },
        dayPanel: {
            titleWithDate: "Einträge für {{date}}",
            emptyDay: "Keine Drinks am {{date}} erfasst.",
            entryTitle: "{{drink}} - {{amount}} ml",
            totalLabel: "Gesamt: {{amount}} ml",
            queued: "wartet auf Sync",
            rejected: "nicht synchronisiert",
        },
        empty: {
            title: "Noch kein Trinkverlauf",
            description: "Erfasse einen Drink, um deinen Verlauf aufzubauen.",
        },
        messages: {
            loadActivitiesError: "Trinkverlauf konnte nicht geladen werden.",
        },
    },
    recap: {
        authRequired: {
            title: "Anmeldung benötigt",
            description: "Melde dich an, um deinen privaten Jahresrückblick zu sehen.",
        },
        loading: "Dein Jahresrückblick wird geladen",
        loadError: "Deine Einträge konnten nicht geladen werden.",
        retry: "Erneut versuchen",
        page: {
            title: "Jahresrückblick",
            subtitle: "Eine sachliche Übersicht deiner eigenen erfassten Drinks.",
        },
        yearLabel: "Kalenderjahr",
        summary: "Im Jahr {{year}} hast du {{drinks}} Drinks an {{days}} Tagen erfasst.",
        privacy: "Nur du kannst das sehen.",
        empty: "Im Jahr {{year}} wurden keine Drinks erfasst.",
        hidden: "Dein Jahresrückblick ist auf diesem Gerät ausgeblendet.",
        hide: "Rückblick ausblenden",
        show: "Rückblick anzeigen",
        metrics: {
            totalDrinks: "Erfasste Drinks",
            drinkingDays: "Tage mit erfassten Drinks",
            average: "Durchschnitt pro Trinktag",
            busiestMonth: "Monat mit den meisten Drinks",
            mostFrequentDrink: "Am häufigsten erfasster Drink",
        },
        monthly: {
            title: "Erfasste Drinks pro Monat",
            chartLabel: "Anzahl der im Jahr {{year}} pro Monat erfassten Drinks",
            tableLabel: "Monatszahlen als Tabelle anzeigen",
            month: "Monat",
            drinks: "Erfasste Drinks",
        },
        comparison: {
            title: "Vergleich mit {{year}}",
            neutral: "Unterschied bei erfassten Drinks: {{difference}}",
            noData: "Für das Vorjahr liegen keine Daten vor.",
        },
    },
    tournaments: {
        noActiveEvent: { title: "Kein aktives Event", description: "Tritt einem Event bei oder starte eins, um seine Turniere zu sehen." },
        loadError: "Turniere konnten nicht geladen werden.",
        loading: "Turniere werden geladen",
        loadingOne: "Turnier wird geladen",
        retry: "Erneut versuchen",
        eventNotFound: { title: "Event nicht gefunden", description: "Wähle ein gültiges Event, um seine Turniere zu sehen." },
        completed: "Beendet",
        inProgress: "Läuft",
        eventFallback: "Event {{id}}",
        create: "Turnier erstellen",
        title: "Turniere",
        discipline: { beerpong: "Beerpong" },
        open: "Öffnen",
        noneNew: "Noch keine neuen Turniere.",
        newSection: "Neue Turniere",
        runningSection: "Laufende Turniere",
        noneRunning: "Keine laufenden Turniere.",
        older: "Abgeschlossene Turniere",
        noneCompleted: "Noch keine abgeschlossenen Turniere.",
        inProgressClassic: "Laufende klassische Turniere",
        openClassic: "Klassische Verwaltung öffnen",
        classic: "Klassisch",
        noneClassic: "Keine klassischen Turniere für dieses Event.",
        signInToCreate: "Melde dich an und tritt einem Event bei, bevor du ein Turnier erstellst.",
        signInEmpty: "Melde dich an und tritt einem Event bei, um ein Turnier zu erstellen.",
        enterNameEntrants: "Gib einen Turniernamen und mindestens zwei benannte Teilnehmer ein.",
        enterPassword: "Gib ein Passwort für dieses Turnier ein.",
        shareLinkFailed: "Turnier erstellt, aber der öffentliche Link konnte nicht aktiviert werden.",
        createError: "Turnier konnte nicht erstellt werden.",
        creating: "Turnier wird erstellt…",
        visibility: { label: "Sichtbarkeit", public: "Öffentlich", friends: "Freunde", password: "Passwortgeschützt", private: "Privat" },
        passwordLabel: "Passwort",
        passwordAria: "Turnierpasswort",
        saveResultError: "Ergebnis konnte nicht gespeichert werden.",
        updateEntrantError: "Teilnehmer konnte nicht aktualisiert werden.",
        signInToOpen: "Melde dich an, um dieses Turnier zu öffnen.",
        notFound: "Turnier nicht gefunden.",
        playerView: "Spieleransicht",
        organizerView: "Organisatoransicht",
        liveUnavailable: "Live-Update nicht verfügbar. Neuer Versuch…",
        liveUpdated: "Live · vor {{seconds}} s aktualisiert",
        liveStaleUpdated: "Veraltet · vor {{seconds}} s aktualisiert",
        yourNext: "Dein nächstes Match",
        noUpcoming: "Dir ist kein kommendes Match zugewiesen.",
        bracket: "Turnierbaum",
        standings: "Tabelle",
        joinError: "Beitritt zum Turnier fehlgeschlagen.",
        join: "Turnier beitreten",
        entrants: "Teilnehmer",
        advanceError: "Turnier konnte nicht weitergeschaltet werden.",
        advancePendingMatches: "Melde zuerst alle offenen Matches, bevor du die nächste Phase startest.",
        advance: "Nächste Phase",
        shareError: "Freigabelink konnte nicht aktualisiert werden.",
        revokeShare: "Freigabelink widerrufen",
        createShare: "Freigabelink erstellen",
    },
};

export default de;
